import DashboardIcon from "@mui/icons-material/Dashboard";
import {Button, Grid, IconButton, Tooltip} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {getNodeDashboardsInternalUrl} from "../../../constants/appRoutes";
import {HEADER_BUTTON_VIEW_MODE_ICONTEXT, HEADER_BUTTON_VIEW_MODE_TEXT, showNodeDashboardsButton} from "../utils";

const DashboardButton = ({moduleConfigs, node, hub, viewMode}) => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  return (
    showNodeDashboardsButton(moduleConfigs, node, hub) && (
      <Grid className="dashboards-btn">
        {viewMode === HEADER_BUTTON_VIEW_MODE_TEXT ? (
          <Button
            id="header_dashboard_text_button_btn"
            variant="text"
            onClick={() => navigate(getNodeDashboardsInternalUrl(node.code))}
            aria-label={t("components.header.actions.dashboard.ariaLabel")}
            sx={{color: theme => theme.palette.primary.contrastText}}
          >
            {t("components.header.actions.dashboard.label")}
          </Button>
        ) : viewMode === HEADER_BUTTON_VIEW_MODE_ICONTEXT ? (
          <Button
            id="header_dashboard_text_button_btn"
            variant="text"
            startIcon={<DashboardIcon />}
            onClick={() => navigate(getNodeDashboardsInternalUrl(node.code))}
            aria-label={t("components.header.actions.dashboard.ariaLabel")}
          >
            {t("components.header.actions.dashboard.label")}
          </Button>
        ) : (
          <Tooltip title={t("components.header.actions.dashboard.title")}>
            <IconButton
              id="header_dashboard_icon_button_btn"
              onClick={() => navigate(getNodeDashboardsInternalUrl(node.code))}
              aria-label={t("components.header.actions.dashboard.ariaLabel")}
            >
              <DashboardIcon />
            </IconButton>
          </Tooltip>
        )}
      </Grid>
    )
  );
};

export default DashboardButton;
